// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';

import type { Database } from './types';

const SUPABASE_URL =
  String(import.meta.env.VITE_SUPABASE_URL) || 'https://gfnynyaqmsgrfmgevdaz.supabase.co';
const SUPABASE_PUBLISHABLE_KEY =
  String(import.meta.env.VITE_SUPABASE_ANON_KEY) ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdmbnlueWFxbXNncmZtZ2V2ZGF6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA2Mzc1MDQsImV4cCI6MjA3NjIxMzUwNH0.SXsxIqz4fElYCMggXZjP2rARMDYAm-IsQmCzqBUl7U4';

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true, // Important for OAuth flows
    flowType: 'pkce', // Use PKCE flow for better security
    // Session storage customization
    storageKey: 'medipaths-auth-token',
  },
  realtime: {
    // Disable realtime to avoid WebSocket connection errors in development
    // This can be re-enabled when realtime subscriptions are needed
    params: {
      eventsPerSecond: 10,
    },
  },
  global: {
    headers: {
      'X-Client-Info': 'medipaths-web',
    },
  },
});
